import { createContext, useContext } from 'react'

/**
 * Lets any screen open the help panel, at the article for the current page
 * (no slug) or at a named one. Provided by AppShell, which owns the panel, so
 * a screen never imports the panel itself.
 */
export const HelpContext = createContext<{ open: (slug?: string) => void } | null>(null)

export function useHelp() {
  return useContext(HelpContext)
}
